import { OrderOverview } from 'projects/flow-gui-access/views/middlewares/orders'

module.exports = [
  {
    path: '/orders',
    exact: true,
    component: OrderOverview
  }
]



// WEBPACK FOOTER //
// ./src/projects/flow-gui-access/routes/orders.js